// extracted by mini-css-extract-plugin
export default {"threedotsBtn":"style_threedotsBtn__VoBpI","featureRowData":"style_featureRowData__-yu4F"};